const sectionReviewGrid04Css = `
[data-type='section-review-grid-04'] .review-grid-wrapper {
  background-color: var(--background-color, #ffffff);
}

[data-type='section-review-grid-04'] .review-grid-wrapper[data-top-padding='true'] {
  padding-top: 40px;
}

[data-type='section-review-grid-04'] .review-grid-wrapper[data-bottom-padding='true'] {
  padding-bottom: 40px;
}

[data-type='section-review-grid-04'] .review-grid-wrapper[data-show-tags='false'] .review-tags {
  display: none;
}

[data-type='section-review-grid-04'] .review-grid-wrapper[data-show-avatar-border='false'] .review-grid-items-wrapper .review-grid-items .review-grid-item .reviewer-avatar-wrapper {
  box-shadow: none;
}

[data-type='section-review-grid-04'] .review-header:not(:empty) {
  margin-bottom: 24px;
}

[data-type='section-review-grid-04'] .review-header h1,
[data-type='section-review-grid-04'] .review-header h2,
[data-type='section-review-grid-04'] .review-header h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 16px 0 !important;
  color: var(--text-color, #000000);
}

[data-type='section-review-grid-04'] .review-header h1:last-child,
[data-type='section-review-grid-04'] .review-header h2:last-child,
[data-type='section-review-grid-04'] .review-header h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-review-grid-04'] .review-header p {
  font-size: 14px;
  margin: 0 0 8px 0 !important;
  line-height: normal;
  color: var(--text-color, #000000);
}

[data-type='section-review-grid-04'] .review-header p:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-review-grid-04'] .review-tags {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 4px;
  margin-bottom: 24px;
}

[data-type='section-review-grid-04'] .review-tags .review-tag-item {
  background-color: var(--tag-background-color, #ebeced);
  color: var(--tag-text-color, #000000);
  font-weight: 500;
  padding: 10px 15px 10px;
  border-radius: var(--tag-border-radius, 0);
  font-size: 16px;
  cursor: pointer;
}

[data-type='section-review-grid-04'] .review-tags .review-tag-item:hover {
  background-color: var(--primary-color, #14a16c);
  color: var(--tag-active-text-color, #ffffff);
}

[data-type='section-review-grid-04'] .review-tags .review-tag-item.active {
  background-color: var(--primary-color, #14a16c);
  color: var(--tag-active-text-color, #ffffff);
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper {
  color: var(--text-color, #000000);
  background-color: var(--reviews-list-background-color, #f5f6f7);
  padding: 30px 0;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items {
  --items-gap: 64px;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  gap: var(--items-gap);
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item-empty {
  display: none;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: var(--text-color, #000000);
  opacity: 0.6;
  width: 100%;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item {
  --item-basis-desktop: calc(
    (100% - (var(--items-per-row-desktop, 2) - 1) * var(--items-gap)) / var(--items-per-row-desktop, 2)
  );
  --item-basis-mobile: calc(
    (100% - (var(--items-per-row-mobile, 1) - 1) * var(--items-gap)) / var(--items-per-row-mobile, 1)
  );

  flex: 0 0 var(--item-basis-desktop);
  max-width: var(--item-basis-desktop);

  display: flex;
  flex-direction: row;
  gap: 16px;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .reviewer-avatar-wrapper {
  border-radius: 50%;
  box-shadow: 0 0 0 6px var(--primary-color, #14a16c);
  max-width: var(--avatar-size-desktop, 200px);
  max-height: var(--avatar-size-desktop, 200px);
  width: 100%;
  height: fit-content;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .reviewer-avatar-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container {
  flex: 1;
  width: 100%;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-title {
  font-weight: 700 !important;
  font-size: 20px;
  line-height: normal;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-title:not(:empty) {
  margin: 0 0 12px 0 !important;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-content {
  margin: 0 !important;
  line-height: normal;
  line-clamp: var(--text-line-clamp, 2);
  -webkit-line-clamp: var(--text-line-clamp, 2);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-content:not(:empty) {
  margin: 0 0 12px 0 !important;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-content.is-expanded {
  line-clamp: unset;
  -webkit-line-clamp: unset;
  display: block;
  overflow: visible;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-footer {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-footer .reviewer-name {
  margin: 0 !important;
  font-weight: 500 !important;
}

[data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-footer .read-more-button {
  background-color: var(--primary-color, #14a16c);
  color: var(--button-text-color, #ffffff);
  display: block;
  padding: 10px 16px;
  text-align: center;
  border-radius: var(--button-border-radius, 24px);
  text-decoration: none;
  width: fit-content;
  height: fit-content;
  font-size: 13px;
  line-height: normal;
}

[data-type='section-review-grid-04'] .load-more-button-wrapper {
  display: flex;
  justify-content: center;
}

[data-type='section-review-grid-04'] .load-more-button-wrapper :not(:empty) {
  margin-top: 24px !important;
}

[data-type='section-review-grid-04'] .load-more-button-wrapper .load-more-button {
  background-color: var(--primary-color, #14a16c);
  color: var(--button-text-color, #ffffff);
  display: block;
  padding: 10px 20px;
  text-align: center;
  border-radius: var(--button-border-radius, 24px);
  text-decoration: none;
  width: fit-content;
  font-size: 13px;
  line-height: normal;
}

@container (max-width: 768px) {
  [data-type='section-review-grid-04'] .review-grid-wrapper[data-top-padding='true'] {
    padding-top: 16px;
  }

  [data-type='section-review-grid-04'] .review-grid-wrapper[data-bottom-padding='true'] {
    padding-bottom: 16px;
  }

  [data-type='section-review-grid-04'] .review-header h1,
  [data-type='section-review-grid-04'] .review-header h2,
  [data-type='section-review-grid-04'] .review-header h3 {
    font-size: 20px;
  }

  [data-type='section-review-grid-04'] .review-tags {
    row-gap: 8px;
  }

  [data-type='section-review-grid-04'] .review-tags .review-tag-item {
    font-size: 14px;
    padding: 4px 12px;
  }

  [data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items {
    --items-gap: 32px;
  }

  [data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item {
    flex-basis: var(--item-basis-mobile);
    max-width: var(--item-basis-mobile);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
  }

  [data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .reviewer-avatar-wrapper {
    max-width: var(--avatar-size-mobile, 150px);
    max-height: var(--avatar-size-mobile, 150px);
  }

  [data-type='section-review-grid-04'] .review-grid-items-wrapper .review-grid-items .review-grid-item .review-info-container .review-title {
    font-size: 18px;
  }
}
`;
export default sectionReviewGrid04Css;
